import React from 'react';
import PropTypes from 'prop-types';
import VariationSelector from './VariationSelector';

const ABTestWithFallback = (props) => {
  const checkVariationCount = (variationCount) => variationCount === 2;
  return <VariationSelector checkVariationCount={checkVariationCount} {...props} />;
};

ABTestWithFallback.propTypes = {
  flagKey: PropTypes.string.isRequired,
  fallbackKey: PropTypes.string.isRequired,
  variationKeyList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ABTestWithFallback;
